import service from './request'

const post = (url, params) => (data, config) => service.post(url, data, config)
const get = url => config => service.get(url, config)
// export const login = post('/api1/cueretail/api/auth/login')
export const chooseCid = post('/api1/cueretail/api/current/selectcus')

export const querylist = post('/api/animix/ad/machine/order/page')

export const querydev = get('/api/animix/ad/machine/device/list')

export const deviceListReq = get('/api/animix/ad/machine/device/deviceList')

export const imageListReq = post('/api/animix/ad/machine/image/page')

// 数据查询分页接口
// export function dataPageReq(params) {
//   return service({
//     url: '/api/animix/ad/machine/order/data/page',
//     method: 'get',
//     params
//   })
// }

export const login = post('/api1/cueretail/api/auth/login/animix') //new login

export const dataPageReq = post('/api/animix/ad/machine/order/data/page') // 数据查询分页接口-门店

export const getOrgInfo = post('/api/animix/ad/machine/deviceManage/getOrgInfo') //获取门店信息

export const orderRefund = post('/api/animix/ad/machine/order/cancel') //退款

export const deviceManagePageReq = post('/api/animix/ad/machine/deviceManage/page') // 设备查询分页接口

export const attUpdateReq = post('/api/animix/ad/machine/deviceManage/attUpdate') // 设备名称更新

export const dataActivityPageReq = post('/api/animix/ad/machine/order/activity/page') // 数据查询分页接口-活动

export const dataActivityDetailPageReq = post('/api/animix/ad/machine/order/activity/info') // 数据活动详情

export const getActivityDetailReq = post('/api/animix/ad/machine/order/activity/getActivity') // 数据活动详情

export const getAttActivityReq = post('/api/animix/ad/machine/deviceManage/attActivity') // 获取设备活动日历

export const getImageActivityReq = post('/api/animix/ad/machine/image/activity/page') // 获取图片活动列表

export const updatePasswordReq = post('/api1/cueretail/api/current/changePwd') // 修改密码

export const getActivityInfoReq = post('/api/animix/ad/machine/image/activity') // 获取图片活动列表

export const exportOrderExcel = post('/api/animix/ad/machine/order/exportOrderExcel') // 订单管理列表的下载

export const exportOrderDataExcel = post('/api/animix/ad/machine/order/exportOrderDataExcel') // 数据统计列表的下载

export const exportActivityInfoExcel = post('/api/animix/ad/machine/order/exportActivityInfoExcel') // 数据统计活动详情的下载


// 主订单详情数据
export function orderInfoReq(params) {
  return service({
    url: '/api/animix/ad/machine/order/info',
    method: 'get',
    params
  })
}

// 子订单详情
export function suborderReq(params) {
  return service({
    url: '/api/animix/ad/machine/order/suborder',
    method: 'get',
    params
  })
}

// 每个订单的退款数据列表
export function refundListReq(params) {
  return service({
    url: '/api/animix/ad/machine/refund/list',
    method: 'get',
    params
  })
}

export const orderCancelSubReq = post('/api/animix/ad/machine/order/cancel/sub') // 部分退款

export const refundPageReq = post('/api/animix/ad/machine/refund/page') // 退款分页

export const refundExportExcelReq = post('/api/animix/ad/machine/refund/exportExcel') // 导出退款数据











